export default {"src":"/_next/static/media/member-taking-medication-tobacco.colour.eedd1c74.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};